export default "__VITE_ASSET__D376LK0v__"